import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { FormatDate } from "utils/dateUtils";
import { IRevers } from "Dashboard/scenes/Resources/domain/IRevers";
import { useEffect, useState } from "react";
import { ILicense } from "Dashboard/domain/ILicense";
import { settingsService } from "Dashboard/services/settings.service";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { useSelector } from "react-redux";

export interface IProps {
  revers: IRevers | undefined;
}

const PrintRevers = ({ revers }: IProps) => {
  const memorandumLogo = useMemorandumLogo();
  const [license, setLicense] = useState<ILicense>();
  const { user } = useSelector(selectStateAuth);

  useEffect(() => {
    const fetchLicense = async () => {
      const licence = await settingsService.getLicense();
      setLicense(licence);
    }

    fetchLicense();
  }, []);

  return (
    <div className="receiptPrint">
      <div className="receipt-header">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <span className="header">
          <h1>REVERS br: {revers?.orderNumber}</h1>
        </span>
        <div className="additional-info">
          <div>
            <p>Projekat:</p>
            <p>{revers?.projectName}</p>
          </div>
          <p>
            Mesto i datum: {license?.address}{" "}
            <span>
              {revers?.createdAt && FormatDate(revers?.createdAt)}
            </span>
          </p>
        </div>
      </div>
      <div className="receipt-print-content">
        <div className="receipt-print-th">
          <div>količina</div>
          <div>naziv resursa</div>
        </div>
        <div className="receipt-print-t">
          {revers?.charges &&
            revers.charges.map((charge, index) => (
              <div className="row" key={charge.chargeId}>
                <div>{charge.quantity}</div>
                <div>{charge.resourceName}</div>
              </div>
            ))}
        </div>
      </div>
      <div className="line"></div>
      <div className="signatures">
        <div>
          <p>Potpis _______________</p>
          <p>Izdao {user?.name}</p>
        </div>
        <div>
          <p>Potpis ________________</p>
          <p>Primio {revers?.employeeName}</p>
        </div>
      </div>
    </div>
  );
};

export default PrintRevers;
